/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, convertHexToRGB, classStyleHelper } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// NAV
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	nav: {
		extend: [classStyleHelper.direction, classStyleHelper.align],

		// variant
		'&.variant-bubble': {
			display: 'flex',
			flexWrap: 'wrap',
			alignItems: 'center',
			alignContent: 'center',
			justifyContent: 'flex-start',
			'& .link': {
				borderRadius: pxToEm(22),
				color: theme.color.supporting.dark.swatch,
				fontSize: pxToEm(14),
				padding: replacePXinStringWithEM(`10px 20px`),
				marginRight: pxToEm(10),
				'&:hover': {
					background: convertHexToRGB(theme.color.secondary.medium.swatch, 10)
				},
				'&.isActive-true': {
					background: convertHexToRGB(theme.color.primary.medium.swatch, 10),
					color: theme.color.primary.medium.swatch
				}
			}
		},

		// intrapage
		'&.variant-intrapage': {
			border: `1px solid rgb(239, 239, 239)`,
			'& .navitem': {
				borderBottom: `1px solid rgb(239, 239, 239)`,
				width: '100%',
				height: pxToEm(54),
				'& .link': {
					fontSize: pxToEm(14),
					width: '100%',
					height: '100%',
					padding: replacePXinStringWithEM(`0 20px`),
					'&:hover': {
						background: convertHexToRGB(theme.color.secondary.medium.swatch, 10)
					},
					'&.isActive-true': {
						background: `rgb(250, 251, 252)`,
						fontWeight: '500'
					}
				},
				'&:last-child': {
					borderBottom: '0'
				}
			}
		},

		// subnav
		'&.name-subnav': {
			background: theme.color.supporting.light.swatch,
			padding: replacePXinStringWithEM(`13px ${theme.spacing.sides}`),
			borderBottom: replacePXinStringWithEM(`1px solid ${theme.color.grey.medium.swatch}`),

			// animation
			opacity: '0',
			animationName: 'fadeInLeft',
			animationDelay: '.1s',
			animationDuration: '.2s',
			animationFillMode: 'forwards',
		}
	}
});